export const BASE_URL_CDN_3D_ASSETS =
  "https://nvs-static-3d-assets.s3.us-west-2.amazonaws.com";
export const CUSTOMER_SUPPORT_LINK = "https://www.nike.com/help/a/dot-swoosh";
export const NARVAR_RETURNS_GB_EXTERNAL_LINK =
  "https://returns.narvar.com/nike-dotswoosh/returns?locale=en_GB";
export const NARVAR_RETURNS_EU_EXTERNAL_LINK =
  "https://returns.narvar.com/nike-dotswoosh/returns?locale=en_NL";
